export const EDIT = 'Edit';

export const EMAIL = 'Email';
export const PHONE = 'Phone';
export const DATE_OF_BIRTH = 'Date Of Birth';
export const ADDRESS = 'Address';

export const DEFAULT_EMAIL = 'JohnDoe@email.com';
export const DEFAULT_NUMBER = '111 111 1111';
export const DEFAULT_DOB = '**/**/****';
export const STREET_ADDRESS = 'Street Address';
export const APT_UNIT = 'Apt / Unit (optional)';
export const CITY = 'City';
export const STATE = 'State';
export const ZIP_CODE = 'Zip Code';
